import React from 'react';

import { graphql, compose } from 'react-apollo';
import _ from 'lodash';

import {
  Input,
  Select,
  Row,
  Tooltip,
  Col,
  Button,
  notification,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import getTalonarios from '../../../graphql/querys/otros/getTalonarios.graphql';
import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import TablaParTalonarios from '../../editor/TablaParTalonarios';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;

@compose(
  graphql(getTalonarios, {
    name: 'talonarios',
  }),
  graphql(getOrganismos)
)
class FormTipoExpediente extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
      organismoSeleccionado: '',
      paresTalonariosSelector: [],
      paresPosibles: [],
      talonarioSeleccionado: [],
      talonarios: [],
      organismos: [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.data.getOrganismos && nextProps.data.getOrganismos) {
      this.generarOpcionesTalonarios(nextProps.data.getOrganismos);
    }
    if (this.props.data.getOrganismos) {
      this.generarOpcionesTalonarios(this.props.data.getOrganismos);
    }

    if (
      this.props.datos &&
      !this.props.datos.talonarios &&
      nextProps.datos &&
      nextProps.datos.talonarios
    ) {
      this.setState({
        talonarios: nextProps.datos.talonarios,
      });
    }
  }

  generarOpcionesTalonarios = organismos => {
    let valores = [];
    if (organismos) {
      organismos.map(organismo => {
        valores[organismo._id] = organismo.talonarios;
      });
    }

    this.setState({
      paresPosibles: valores,
    });

    return valores;
  };

  agregarPar = () => {
    // console.log(this.state);

    let organismo = _.find(this.props.data.getOrganismos, {
      _id: this.state.organismoSeleccionado,
    });
    let talonario = _.find(
      this.state.paresPosibles[this.state.organismoSeleccionado],
      {
        _id: this.state.talonarioSeleccionado,
      }
    );

    if (organismo && talonario) {
      let obj = {
        organismo,
        talonario,
      };

      if (
        !_.find(this.state.talonarios, {
          organismo: { _id: this.state.organismoSeleccionado },
        })
      ) {
        this.setState({
          ...this.state,
          organismoSeleccionado: '',
          talonarioSeleccionado: '',
          talonarios: _.concat(this.state.talonarios, obj),
        });
      } else {
        notification.warning({
          message: 'Ya existe el organismo',
          description:
            'El organismo que intenta agregar, ya fue agregado previamente. Si quiere modificar su talonario, primero proceda a su eliminación y vuelva a agregarlo.',
        });
      }
    } else {
      notification.error({
        message: 'Faltan datos',
        description:
          'Debe seleccionar un organismo y su talonario para poder agregarlo.',
      });
    }
  };

  removerPar = idOrganismo => {
    let copia = [...this.state.talonarios];
    let nuevosPares = _.pullAllWith(copia, [idOrganismo], (valA, valB) => {
      return valA.organismo._id == valB;
    });

    console.log(nuevosPares);
    this.setState({
      ...this.state,
      talonarios: nuevosPares,
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
        this.props.onSubmit({
          nombre: values.nombre,
          descripcion: values.descripcion,
          talonarios: this.state.talonarios,
        });
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  onCancel = () => {
    this.props.onCancel();
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 4 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 20 },
        sm: { span: 20 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 8,
          offset: 8,
        },
      },
    };

    let botonAgregarPar = (
      <Button onClick={this.agregarPar} type="primary">
        Agregar
      </Button>
    );

    let selectorOrganismos = (
      <Select
        style={{ width: 350 }}
        id="organismos"
        // mode="multiple"
        placeholder="Seleccione los organismos"
        value={this.state.organismoSeleccionado}
        onSelect={valor =>
          this.setState(
            {
              ...this.state,
              organismoSeleccionado: valor,
              talonarioSeleccionado: '',
              paresTalonariosSelector: _.get(this.state.paresPosibles, valor),
            },
            () => {
              this.state.talonarioSeleccionado = '';
            }
          )
        }
        onDeselect={() =>
          this.setState({
            ...this.state,
            organismoSeleccionado: '',
            talonarioSeleccionado: '',
            paresTalonariosSelector: [],
          })
        }
      >
        {this.props.data.getOrganismos &&
          this.props.data.getOrganismos.map(organismo => (
            <Select.Option key={organismo._id}>
              {organismo.nombre}
            </Select.Option>
          ))}
      </Select>
    );

    let selectorTalonarios = (
      <Select
        style={{ width: 350 }}
        id="talonarios"
        /* eslint-disable-next-line react/no-string-refs */
        ref="talonarios"
        placeholder="Seleccione el talonario"
        value={this.state.talonarioSeleccionado}
        onSelect={valor =>
          this.setState({
            ...this.state,
            talonarioSeleccionado: valor,
          })
        }
      >
        {this.state.paresPosibles[this.state.organismoSeleccionado] &&
          this.state.paresPosibles[this.state.organismoSeleccionado].map(
            talonario => (
              <Select.Option key={talonario._id}>
                {talonario.nombre}
              </Select.Option>
            )
          )}
      </Select>
    );

    // console.log('PROPS');
    // console.log(this.props);

    return (
      <div>
        <h1 className="tituloForm">Datos del Tipo de Expediente</h1>

        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Nombre
                <Tooltip title="El nombre que se mostrara del tipo de expediente ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('nombre')(<Input />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Descripcion
                <Tooltip title="Una breve descripcion del tipo de expediente ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('descripcion')(<Input />)}
          </FormItem>

          <div>
            <Row>
              <Col span={10} offset={2}>
                <div className="inputs">
                  <h3>Organismo del Talonario: </h3>
                  {selectorOrganismos}
                </div>
              </Col>
              <Col span={10}>
                <div className="inputs">
                  <h3>Talonario a Agregar: </h3>
                  {selectorTalonarios}
                </div>
              </Col>

              <Col span={2}>
                <div className="inputs">
                  <h3> Acciones: </h3>
                  {botonAgregarPar}
                </div>
              </Col>
            </Row>

            {this.state.talonarios.length > 0 && (
              <Row>
                <Col offset={2} span={20}>
                  <TablaParTalonarios
                    removerPar={this.removerPar}
                    pares={this.state.talonarios}
                  />
                </Col>
              </Row>
            )}
          </div>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Guardar Datos
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              type="danger"
              onClick={this.onCancel}
            >
              Cancelar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    return {
      nombre: Form.createFormField({
        value: props.datos ? props.datos.nombre : '',
      }),
      descripcion: Form.createFormField({
        value: props.datos ? props.datos.descripcion : '',
      }),
      talonario: Form.createFormField({
        value:
          props.datos && props.datos.talonario ? props.datos.talonario._id : '',
      }),
    };
  },
})(FormTipoExpediente);
